<template>
  <div id="legend">
    <div id="l_units">{{legend.title}}</div>
    <div id="legend_container">
      <template v-if="legend.type == 'ramp'">
        <div v-if="legend.range" id="l_labels" class="d-flex flex-column">
          <div class="flex-fill text-end" v-for="index in legend.num_labels" v-bind:key="index">
            {{label(index-1)}}
          </div>
        </div>
        <div v-if="legend.labels" id="l_labels" class="d-flex flex-column">
          <div class="flex-fill text-end position-relative" v-for="t_label in legend.labels" v-bind:key="t_label">
            <span class="position-absolute bottom-0 end-0">{{t_label}}</span>
          </div>
        </div>
        <div id="l_colors" class="d-flex flex-column">
          <div class="flex-fill" :style="prepareGradient()"></div>
        </div>
      </template>
      <template v-if="legend.type == 'markers'">
        <div id="l_markers" class="d-flex flex-column">
          <div class="pb-3" v-for="(marker, index) in legend.markers" v-bind:key="index">
            <img :src="'/map_icons/'+marker.src"/>
            {{marker.label}}
          </div>
        </div>
      </template>
      <template v-if="legend.type == 'values'">
        <div id="l_values" class="d-flex flex-column">
          <div class="pb-1 position-relative text-end pe-4" v-for="(value, index) in legend.values" v-bind:key="index">
            {{value.label}}
            <span class="position-absolute bottom-0 end-0" :style="'background-color: ' + value.color"></span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  #legend {
    position: relative;
    width: 100%;
    height: 100%;
    border: solid 1px #ccc;
    background-color: white;
  }
  #legend_container {
    position: absolute;
    top: 30px;
    bottom: 0;
    width: 100%;
  }
  #l_units {
    position: absolute;
    top: 0;
    text-align: center;
    width: 100%;
    height: 30px;
    font-size: 16px;
    background-color: #ccc;
    border-bottom: solid 1px #ccc;
  }
  #l_colors {
    position: absolute;
    height: 100%;
    width: 20%;
    right: 0;
    bottom: 0;
    >div{
      min-height: 1px;
    }
  }
  #l_labels {
    position: absolute;
    height: 100%;
    width: 65%;
    left: 0;
    bottom: 0;
  }
  #l_values {
    span {
      width: 20px;
      height: 100%;
    }
  }
</style>

<script>
  export default {
    props: {
      legend: null,
    },
    methods: {
      prepareGradient(){
        const colors = this.legend.stops.map(stop => 'rgba('+ stop.color.r + ',' + stop.color.g + ',' + stop.color.b + ',' + stop.color.a + ')');
        return 'background-image: linear-gradient(to bottom, ' + colors.join(', ') + ')';
      },
      label(index) {
        return Math.floor(this.legend.range[0] + (index/parseFloat(this.legend.num_labels-1))*(this.legend.range[1]-this.legend.range[0]));
      }
    },
    mounted: function(){
    }
  }
</script>